module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/white_ant_prevent.78953cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/phone/product/white_ant_prevent.jpg
// module id = /gwH
// module chunks = 0